import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

export default class ActionHeader extends React.Component {

  /* Render */

  render() {
    const filterMenu = this.renderFilterMenu();
    const sortMenu = this.renderSortingMenu();

    return (
      <div className="action-header align align--fluid align--gutter-sm">
        {filterMenu}
        {filterMenu && <div className="align__cell" />}
        {sortMenu}
        {!filterMenu && <div className="align__cell" />}
        <div className="align__cell align__cell--shrink">
          {this.renderButton('blocks')}
        </div>
        <div className="align__cell align__cell--shrink">
          {this.renderButton('table')}
        </div>
      </div>
    );
  }

  renderArrowSelect(params) {
    const icon = params.isOpen ? 'up' : 'down';

    return (
      <span className={`icon icon-chevron-${icon} icon--xxs`} />
    );
  }

  renderFilterMenu() {
    const { filterOptions, onFilterChange, selectedFilterOption } = this.props;

    if (!onFilterChange && !filterOptions && !selectedFilterOption) return null;

    return (
      <div className="align__cell align__cell--shrink">
        <Select
          arrowRenderer={this.renderArrowSelect}
          className="Select--xs Select--plain Select--font-xs"
          clearable={false}
          disabled={false}
          name="sorting"
          onChange={onFilterChange}
          options={filterOptions}
          searchable={false}
          value={selectedFilterOption}
        />
      </div>
    );
  }

  renderSortingMenu() {
    const { sortOptions, onSortChange, selectedSortOption } = this.props;

    if (!onSortChange && !sortOptions && !selectedSortOption) return null;

    return (
      <div className="align__cell align__cell--shrink">
        <Select
          arrowRenderer={this.renderArrowSelect}
          className="Select--sm Select--plain Select--font-xs Select--no-left-padding"
          clearable={false}
          disabled={false}
          name="sorting"
          onChange={onSortChange}
          options={sortOptions}
          searchable={false}
          value={selectedSortOption}
        />
      </div>
    );
  }

  renderButton(type) {
    const { viewType } = this.props;
    const buttonClassNames = classNames('action-header__button', 'button', 'button', { 'is-active': viewType === type });

    return (
      <button className={buttonClassNames} onClick={() => { this.props.onViewChange(type); }}>
        <div className={`icon icon-${type}`} />
      </button>
    );
  }
}

ActionHeader.propTypes = {
  filterOptions: PropTypes.array,
  onFilterChange: PropTypes.func,
  onSortChange: PropTypes.func,
  onViewChange: PropTypes.func,
  selectedFilterOption: PropTypes.object,
  selectedSortOption: PropTypes.object,
  sortOptions: PropTypes.array,
  viewType: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/action-header/index.jsx